module.exports = __webpack_public_path__ + "static/img/002.692bf41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brand/002.png
// module id = A4an
// module chunks = 1